export default "__VITE_ASSET__eqLr0kqC__"